export default "__VITE_ASSET__6c03ccfe__"